export default __webpack_public_path__ + "static/media/community-paige-icon.42e0d4f0.png";